const ContactPage = () => {
  return (
    <div className="container py-5">
      <h1 className="mb-4">Kontaktirajte nas</h1>

      <p>
        Imate vprašanje, predlog ali potrebujete pomoč? Veseli bomo vašega sporočila!
      </p>

      <h3 className="mt-4 mb-3">E-pošta</h3>
      <p>
        Pišite nam na: <a href="mailto:podpora@bazarc.si">info@bazarc.si</a>
      </p>

      <h3 className="mt-4 mb-3">Obrazec za sporočilo</h3>

      <form>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">Vaše ime</label>
          <input type="text" className="form-control" id="name" placeholder="Vnesite svoje ime" />
        </div>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">E-pošta</label>
          <input type="email" className="form-control" id="email" placeholder="Vnesite svoj e-poštni naslov" />
        </div>
        <div className="mb-3">
          <label htmlFor="message" className="form-label">Sporočilo</label>
          <textarea className="form-control" id="message" rows="5" placeholder="Vnesite vaše sporočilo"></textarea>
        </div>
        <button type="submit" className="btn btn-primary">Pošlji</button>
      </form>
    </div>
  );
};

export default ContactPage;